<!-- <div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div> -->

  <div mat-dialog-title class="d-flex justify-content-between align-items-center pt-2">
  <div class="prese_heading">
    <h2 class="m-0">{{ parentData.title }}</h2>
  </div>
  <div class="prese_button">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  </div>


  <mat-dialog-content >
   
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Working Days</mat-label>
        <input
          [(ngModel)]="newSalaryData.workingDays"
          smNumericOnly
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Paid leave count</mat-label>
        <input
          [(ngModel)]="newSalaryData.paidLeave"
          matInput
          smNumericOnly
          #input
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Unpaid leave count</mat-label>
        <input
          [(ngModel)]="newSalaryData.unPaidLeave"
          matInput
          smNumericOnly
          #input
        />
      </mat-form-field>
    </div>
    <div>
        <mat-form-field appearance="outline">
          <mat-label>Gross Salary</mat-label>
          <input
            [(ngModel)]="newSalaryData.netPayment"
            matInput
            type="number" smDecimalOnly
            #input
            (ngModelChange)="changeRates()"
          />
        </mat-form-field>
      </div>
     <!-- <div>
      <mat-form-field appearance="outline">
        <mat-label>Pay rate</mat-label>
        <input
          [(ngModel)]="newSalaryData.amount"
          matInput
          #input
          type="number" smDecimalOnly
          (ngModelChange)="changeRates()"
        />
      </mat-form-field>
    </div> -->
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Other Perks</mat-label>
        <input
          [(ngModel)]="newSalaryData.otherPerks"
          matInput
          type="number" smDecimalOnly
          #input
          (ngModelChange)="changeRates()"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Perks Type</mat-label>
        <input
          [(ngModel)]="newSalaryData.perksType"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div>
        <mat-form-field appearance="outline">
          <mat-label>Deduction</mat-label>
          <input
            [(ngModel)]="newSalaryData.deduction"
            matInput
            #input
            type="number" smDecimalOnly
            (ngModelChange)="changeRates()"
          />
        </mat-form-field>
      </div>
    <div>
        <mat-form-field appearance="outline">
          <mat-label>Deduction Type</mat-label>
          <input
          [(ngModel)]="newSalaryData.deductionType"
            matInput
            #input
          />
        </mat-form-field>
      </div>
      
      <div>
        <mat-form-field appearance="outline">
          <mat-label>Net pay</mat-label>
          <input
          [readonly]="true"
            [(ngModel)]="newSalaryData.np"
            matInput
            #input
          />
        </mat-form-field>
      </div>

    <div class="radio_group">
        <h3>Salary Type: </h3>
        <div class="salary_type_hesding">
        <mat-radio-group [(ngModel)]="newSalaryData.salaryType">
          <mat-radio-button [value]="1">Normal</mat-radio-button>
          <mat-radio-button [value]="2">Advance</mat-radio-button>
        </mat-radio-group>
        </div>
    </div>

      <div style="padding-left: 7px; color: #5f5f5f;">
        <p *ngIf="newSalaryData.paidOn == 1">Paid On: Daily</p>
        <p *ngIf="newSalaryData.paidOn == 2">Paid On: Weekly</p>
        <p *ngIf="newSalaryData.paidOn == 3">Paid On: Monthly</p>
      </div>
      <div *ngIf="newSalaryData.paidOn == 1">
        <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker0.open()" style="padding: 0px;">
            <mat-label>Select Date</mat-label>
            <input matInput [matDatepicker]="picker0" [(ngModel)]="newSalaryData.salaryFromDate" readonly [max]="newSalaryData.salaryType == 1 ? maxDate : null">
    
            <mat-datepicker-toggle matSuffix [for]="picker0"></mat-datepicker-toggle>
            <mat-datepicker #picker0 disabled="false"></mat-datepicker>
          </mat-form-field>
    </div>
      <div *ngIf="newSalaryData.paidOn == 2">
        <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker1.open()" style="padding: 0px;">
            <mat-label>From Date</mat-label>
            <input matInput [matDatepicker]="picker1" [(ngModel)]="newSalaryData.salaryFromDate" readonly [max]="newSalaryData.salaryType == 1 ? maxDate : null">

            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1 disabled="false"></mat-datepicker>
          </mat-form-field>
    </div>
    <div *ngIf="newSalaryData.paidOn == 2">
        <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker2.open()" style="padding: 0px;">
            <mat-label>To Date</mat-label>
            <input matInput [matDatepicker]="picker2" [(ngModel)]="newSalaryData.salaryToDate" readonly [max]="newSalaryData.salaryType == 1 ? maxDate : null">

            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2 disabled="false"></mat-datepicker>
          </mat-form-field>
    </div>
    <div *ngIf="newSalaryData.paidOn == 3">
        <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker4.open()" style="padding: 0px;">
            <mat-label>Select Month</mat-label>
            <input matInput [matDatepicker]="picker4" [formControl]="date" readonly [max]="newSalaryData.salaryType == 1 ? maxDate : null">
    
            <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
            <mat-datepicker #picker4 disabled="false" startView="multi-year"
            (monthSelected)="setMonthAndYear($event, picker4)"
            panelClass="example-month-picker"></mat-datepicker>
          </mat-form-field>
    </div>

    <div>
        <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker3.open()" style="padding: 0px;">
            <mat-label>Salary Credit Date</mat-label>
            <input matInput [matDatepicker]="picker3" [(ngModel)]="newSalaryData.salary_credit_date" readonly [max]="maxDate">
            <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-datepicker #picker3 disabled="false"></mat-datepicker>
          </mat-form-field>
    </div>

    <div>
        <mat-form-field appearance="outline">
          <mat-label>Notes</mat-label>
          <textarea
            [(ngModel)]="newSalaryData.notes"
            matInput
          ></textarea>
        </mat-form-field>
      </div>
      
  </mat-dialog-content>
<!-- 
  <mat-dialog-content *ngIf="editMode">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Amount</mat-label>
        <input
          [(ngModel)]="editCreditData.amount"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div class="radio_group">
        <label>Status: </label>
        <mat-radio-group [(ngModel)]="editCreditData.status">
          <mat-radio-button [value]="1">Active</mat-radio-button>
          <mat-radio-button [value]="0">Paid Fully</mat-radio-button>
        </mat-radio-group>
      </div>
  </mat-dialog-content> -->
  
  <mat-dialog-actions align="end" >
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
            [disabled]="!newSalaryData.netPayment"
      (click)="onPost()"
    >
      Confirm
    </button>
  </mat-dialog-actions>
  